import { render } from "./subcategory.vue?vue&type=template&id=0fb85fda&scoped=true"
import script from "./subcategory.vue?vue&type=script&lang=js"
export * from "./subcategory.vue?vue&type=script&lang=js"

import "./subcategory.vue?vue&type=style&index=0&id=0fb85fda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fb85fda"]])

export default __exports__